//
//
//
//
//
//
//
//

import  { mapGetters, mapActions } from "vuex";
import loader from "./components/loader.vue";
import locator from './components/locator.vue';


export default {
  name: "Dealer-Locator",
	components: {
		loader,
		locator,
	},
  data: function () {
    return {
	    location: null,
    };
  },
  computed: {
		...mapGetters(["config", "loading"]),
	  showDetail() {
			return this.location !== null;
	  }
	},
  methods: {
		...mapActions(["loadConfig"]),
	},
	created() {
		this.loadConfig(this.$root.config);
	},
};
